module.exports = __webpack_public_path__ + "img/truck-question.6e338b66.svg";